import Header from "./Header.jsx";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const dir = i18n.dir();

  return (
    <section className="hero-section-landing">
      <Header />
      <div className="hero-content-landing">
        <div className="hero-left">
          <h1 className="hero-title">
            <Trans i18nKey="hero.title">
              Where Every <span>Pet's Story</span> Begins
            </Trans>
          </h1>
          <h2 className="hero-subtitle">
            {t('hero.subtitle')}
          </h2>
          <p className="hero-desc">
            <Trans i18nKey="hero.body">
              From loyal companions to curious creatures,{" "}
              <span className="hero-brand">Sulhafa</span> is where your pet's
              wellness, your convenience, and your community converge in one
              seamless platform.
            </Trans>
          </p>
          
        </div>
        <div className={`hero-right ${dir === "rtl" ? "rtl" : ""}`}>
          <svg
            className="hero-bg-shape"
            width="881"
            height="768"
            viewBox="0 0 881 768"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              position: "absolute",
              top: "-59px",
              right: "-350px",
              zIndex: 1,
            }}
          >
            <path
              d="M877.098 412.734C898.246 667.448 819.639 745.236 555.851 767.137C318.064 487.093 249.921 315.171 0.41522 49.0452C185.799 49.1205 132.534 20.913 354.194 2.50917C633.405 -20.6731 855.949 158.02 877.098 412.734Z"
              fill="#00D4B3"
            />
          </svg>
          <img
            src="/images/Sulhafa-Main.png"
            alt={t("hero.alt.character")}
            className="hero-mascot-img"
          />
        </div>
      </div>
      <div className="hero-wave">
        <svg
          viewBox="0 0 1440 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          style={{ width: "100%", height: "100%", zIndex: 100 }}
        >
          <path
            fill="#A9B7C6"
            fillOpacity="1"
            d="M0,140 Q360,60 720,140 Q1080,220 1440,0 L1440,200 L0,200 Z"
            ></path>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
